import { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { TextFieldCustom, SelectField, DateField } from "./CustomInputs";

const InventoryForm = ({ initialValues, handleFormSubmit, buttonLabel }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [suppliers, setSuppliers] = useState([]);
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/employees/role/supplier`);
        console.log("✅ الموردين المجلوبين:", response.data);
        setSuppliers(response.data);
      } catch (error) {
        console.error(t("error_fetching_suppliers"), error);
      }
    };
    fetchSuppliers();
  }, [t]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={inventorySchema(t)}
      onSubmit={handleFormSubmit}
      enableReinitialize
    >
      {(formik) => {
        console.log("✅ قيمة المورد في Formik:", formik.values.supplier);
        return (
          <form onSubmit={formik.handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                direction: isRTL ? "rtl" : "ltr",
              }}
            >
              <TextFieldCustom
                name="itemName"
                label={t("item_name")}
                formik={formik}
                grid={2}
              />
              <TextFieldCustom
                name="totalQuantity"
                label={t("total_quantity")}
                formik={formik}
                type="number"
                grid={2}
              />
              <TextFieldCustom
                name="minStockLevel"
                label={t("min_stock_level")}
                formik={formik}
                type="number"
                grid={2}
              />
              <SelectField
                name="supplier"
                label={t("supplier")}
                formik={formik}
                options={[
                  { value: "", labelKey: t("select_supplier") }, // خيار افتراضي
                  ...suppliers.map((s) => ({ value: s._id, labelKey: s.name })),
                ]}
                grid={2}
              />
              <DateField
                name="lastPurchaseDate"
                label={t("last_purchase_date")}
                formik={formik}
                grid={2}
              />
              <TextFieldCustom
                name="unitPrice"
                label={t("unit_price")}
                formik={formik}
                type="number"
                grid={2}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{
                  fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif",
                  minWidth: "120px",
                }}
              >
                {buttonLabel}
              </Button>
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

const inventorySchema = (t) =>
  yup.object().shape({
    itemName: yup.string().required(t("required_item_name")),
    totalQuantity: yup
      .number()
      .min(0, t("min_quantity_error"))
      .required(t("required_total_quantity")),
    minStockLevel: yup
      .number()
      .min(0, t("min_stock_error"))
      .required(t("required_min_stock")),
    supplier: yup.string(), // جعل المورد اختياريًا
    lastPurchaseDate: yup.date().required(t("required_purchase_date")),
    unitPrice: yup
      .number()
      .min(0.01, t("min_price_error"))
      .required(t("required_unit_price")),
  });

export default InventoryForm;